import React, { Component } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, TextField, DialogActions, Grid, Dialog, DialogContent, ListSubheader, List, ListItem, ListItemIcon, ListItemText, Checkbox, Typography } from '@material-ui/core';
import { BtnForm } from "../../general/BotonesAccion";
import AppBarModal from '../../general/AppBarModal';
import { obtenerEstadosProceso } from "../../../global/js/funciones";
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from "../../../global/imagenes/emma_w.png";
import { ESTADOS_BECAS } from '../helper';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

function RenderEstados({ estados_siguiente, estado, cambiarSeleccion }) {
  const classes = useStyles();
  return (
    <List
      className={classes.root}
      subheader={<ListSubheader component="div">Seleccione Estado</ListSubheader>}
    >
      {estados_siguiente.map(({ codigo, nombre, valore }) => (
        <ListItem
          key={codigo}
          role={undefined}
          dense
          button
          onClick={() => cambiarSeleccion({ codigo, valore })}
        >
          <ListItemIcon>
            <Checkbox edge="start" checked={estado === codigo} tabIndex={-1} disableRipple />
          </ListItemIcon>
          <ListItemText id={codigo} primary={nombre} />
        </ListItem>
      ))}
    </List>
  );
}

class BecasGestionarMasivo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: true,
      titulo_res: "Cargando..",
      estado: { codigo: "", valore: "" },
      motivo: "",
      estados_siguiente: [],
      porcentaje: "",
    };
  }

  async componentDidUpdate(prevProps) {
    const { modalGestionMasivo, becas } = this.props;
    if (prevProps.modalGestionMasivo !== modalGestionMasivo && modalGestionMasivo) {
      this.reiniciarEstado();
      await this.cargarEstados(becas);
    }
  }

  reiniciarEstado() {
    this.setState({
      cargando: true,
      titulo_res: "Cargando..",
      estado: { codigo: "", valore: "" },
      motivo: "",
      estados_siguiente: [],
      porcentaje: "",
    });
  }

  // Obtiene los estados siguientes (union) para los tipos de beca distintos de la seleccion.
  // Se excluye 'Est_bec_apl' porque requiere volante por-beca (no aplica en masivo).
  cargarEstados = async (becas = []) => {
    const tiposDistintos = [...new Map(becas.map((b) => [b.tipo_beca.id, b])).values()];
    let acumulado = new Map();
    for (let b of tiposDistintos) {
      const estados = await obtenerEstadosProceso(b.tipo_beca.id, [
        { llave: "principal", valor: b.estado_actual.id },
        { llave: "secundario__generica", valor: ESTADOS_BECAS },
      ]);
      (estados || []).forEach(({ secundario }) => {
        if (secundario && secundario.codigo !== "Est_bec_apl") {
          acumulado.set(secundario.codigo, {
            codigo: secundario.codigo,
            nombre: secundario.nombre,
            valore: secundario.valore,
          });
        }
      });
    }
    this.setState({ estados_siguiente: [...acumulado.values()], cargando: false });
  };

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({ [name]: value });
  };

  onSubmit = (e) => {
    e.preventDefault();
    let { estado, motivo, porcentaje } = this.state;
    let { gestionarMasivo, actualizarMensaje } = this.props;
    if (!estado.codigo) {
      actualizarMensaje({ titulo: "Seleccione estado siguiente.", tipo: "info", mostrar: true, tiempo: 6000 });
      return;
    }
    this.setState({ cargando: true, titulo_res: "Enviando.." });
    let data = { mensaje: motivo, estado: estado.codigo, porcentaje };
    gestionarMasivo(data, () => this.setState({ cargando: false, titulo_res: "Cargando.." }));
  };

  pintarEstados() {
    let { estado, estados_siguiente, motivo, porcentaje } = this.state;
    let { becas } = this.props;
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" style={{ color: "#757575" }}>
            {becas.length} solicitud(es) seleccionada(s).
          </Typography>
        </Grid>
        <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
          <RenderEstados
            cambiarSeleccion={(estado) => this.setState({ estado })}
            estado={estado.codigo}
            estados_siguiente={estados_siguiente}
          />
        </Grid>
        {estado.codigo && (
          <>
            {estado.valore === "agregar_porcentaje" && (
              <Grid item xs={12} md={12}>
                <FormControl className="form-control">
                  <TextField
                    value={porcentaje}
                    id="txtPorcentaje"
                    label={"Porcentaje Beca"}
                    name="porcentaje"
                    placeholder={"Escriba el Porcentaje de la Beca"}
                    multiline
                    onChange={this.onChange}
                  />
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} md={12}>
              <FormControl className="form-control">
                <TextField
                  value={motivo}
                  id="txtMotivoMasivo"
                  label={estado.codigo === "Est_bec_neg" ? "Motivo Negado" : "Observaciones"}
                  name="motivo"
                  placeholder={
                    estado.codigo === "Est_bec_neg"
                      ? "Escriba el motivo de negacion de las solicitudes"
                      : "Escriba Observaciones"
                  }
                  multiline
                  onChange={this.onChange}
                />
              </FormControl>
            </Grid>
          </>
        )}
      </Grid>
    );
  }

  render() {
    const { modalGestionMasivo, mostrarGestionMasivo } = this.props;
    const { cargando, titulo_res } = this.state;
    return (
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={modalGestionMasivo}
        onClose={() => mostrarGestionMasivo(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBarModal
          titulo={"¿ Gestionar Solicitudes Seleccionadas ?"}
          mostrarModal={() => mostrarGestionMasivo(false)}
          titulo_accion=""
          accion=""
        />
        <DialogContent style={{ padding: "1" }} className="scroll">
          {cargando ? (
            <TareasTerminadas mensaje={titulo_res} marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true} />
          ) : (
            <div style={{ padding: "5px 0 5px 0" }}>{this.pintarEstados()}</div>
          )}
        </DialogContent>
        <DialogActions>
          <BtnForm texto="CERRAR" callback={() => mostrarGestionMasivo(false)} />
          {!cargando && <BtnForm texto="ACEPTAR" callback={this.onSubmit} />}
        </DialogActions>
      </Dialog>
    );
  }
}

export default BecasGestionarMasivo;
